/**
 * Workouts kept from a Pro subscription that has ended (the API's api/workout/utils/pro-lock.js has the same rule):
 * without Pro, the oldest workout stays usable (the free plan's one) and the others are kept locked, never deleted.
 * The API sends a locked workout without its exercises. Nothing is locked while the account is still loading.
 */

export const isProAccount = (me) => me?.plan === 'pro' && ['active', 'trialing'].includes(me?.subscriptionStatus);

/** The ids of the account's locked workouts. */
export const lockedWorkoutIds = (workouts, me) => {
  if (!me || isProAccount(me) || !workouts || workouts.length <= 1) return new Set();
  const oldest = workouts.reduce((first, workout) => (Number(workout.id) < Number(first.id) ? workout : first));
  return new Set(workouts.filter((workout) => workout.id !== oldest.id).map((workout) => workout.id));
};
